// extracted by mini-css-extract-plugin
module.exports = {"container":"AppliedPromoCodeDetails_container_JJaVg","section":"AppliedPromoCodeDetails_section_2m6yt"};